import { Inject, Injectable } from '@angular/core';
import { Prestation } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class PrestationStore extends DefaultRessourceStore<Prestation> {
    constructor(@Inject(getCrudName(Prestation)) protected crudService: GenericCrudService<Prestation>) { super(crudService) }
}